import { Box, IconButton, Stack, TextField, Tooltip } from '@mui/material'
import { GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid'
import { Close, Delete, Magnify, Sync } from 'mdi-material-ui'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import ConfirmDialog from '../../utils/dialog'

const MemberToolbar = props => {
  const { numSelected, selected, setReload } = props
  const [open, setOpen] = useState(false);

  const UpdateMember = async () => {
      selected.forEach(async item => {
        try {
          await apiService.put(`/users/${item.userid}`, item);
          toast.success('수정 되었습니다');
          setReload(reload => reload + 1);
        } catch (error) {
          console.error(error);
        }
      });
    }

  const DeleteMember = async () => {
    selected.forEach(async user => {
      try {
        await apiService.delete(`/users/${user.userid}`);
        toast.success('회원이 삭제되었습니다.');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error(error);
      }
    });
  }

  const handleConfirm = () => {
    setOpen(false);
    DeleteMember()
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Update'>
              <IconButton sx={{ color: '#006A4E' }} onClick={UpdateMember} >
                <Sync />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={() => { setOpen(true) }} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}

        <TextField
          variant='standard'
          value={props.value}
          onChange={props.onChange}
          placeholder='이름 검색'
          InputProps={{
            startAdornment: <Magnify fontSize='small' />,
            endAdornment: (
              <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                <Close fontSize='small' />
              </IconButton>
            )
          }}
          sx={{
            width: {
              xs: 1,
              sm: 'auto'
            },
            m: theme => theme.spacing(1, 0.5, 1.5),
            '& .MuiSvgIcon-root': {
              mr: 0.5
            },
            '& .MuiInput-underline:before': {
              borderBottom: 1,
              borderColor: 'divider'
            }
          }}
        />
      </Box>
      <ConfirmDialog 
          open={open}
          title={'회원 삭제'}
          content={'선택된 회원을 삭제하시겠습니까?'}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
      />
    </Box>
  )
}

export default MemberToolbar
